const FALLBACK_MESSAGE = 'Failed to process action. Please try again.';

export const parseActionError = (error) => {
  const detail = error?.response?.data?.detail;
  const isStructuredDetail = detail && typeof detail === 'object';
  const publicMessage =
    typeof detail === 'string'
      ? detail
      : detail?.public_message || detail?.message || error?.message || FALLBACK_MESSAGE;

  if (isStructuredDetail) {
    return {
      retryable: detail.retryable === true,
      exactRetrySafe:
        typeof detail.exact_retry_safe === 'boolean' ? detail.exact_retry_safe : undefined,
      retryScope: detail.retry_scope,
      publicMessage,
      referenceId: detail.reference_id,
      category: detail.public_category,
    };
  }

  return {
    retryable: error?.isRetryable === true,
    exactRetrySafe: undefined,
    retryScope: undefined,
    publicMessage,
    referenceId: undefined,
    category: undefined,
  };
};

export const getActionErrorPresentation = (error) => {
  const parsed = parseActionError(error);
  const message = parsed.publicMessage;
  const retryable = parsed.retryable === true && parsed.exactRetrySafe !== false;

  return { message, retryable };
};
